import { generateClient } from "aws-amplify/api";
import { AUTH_MODE } from "constants/config";
import { createNotification, deleteNotification, updateNotification } from "graphql/mutations";
import { listNotifications } from "graphql/queries";
import { onCreateNotification, onDeleteNotification, onUpdateNotification } from "graphql/subscriptions";

const client = generateClient();

const apiListNotifications = async () => {
  try {
    const params = {
      query: listNotifications,
      authMode: AUTH_MODE
    }
    let nextToken = null;
    const notifications = [];
    while (true) {
      params.nextToken = nextToken;
      const res = await client.graphql(params);
      notifications.push(...res.data?.listNotifications?.items);
      nextToken = res.data?.listNotifications?.nextToken;
      if (!nextToken) break;
    }
    notifications.sort((g1, g2) => -g1.createdAt.localeCompare(g2.createdAt));
    return {
      success: true,
      data: notifications
    }
  }
  catch (e) {
    return {
      success: false,
      error: e
    }
  }
}

const apiCreateNotification = async (input) => {
  try {
    const response = await client.graphql({
      query: createNotification,
      variables: {
        input
      },
      authMode: AUTH_MODE
    });
    const notification = response.data?.createNotification;
    return {
      success: true,
      data: notification
    }
  } catch (e) {
    return {
      success: false,
      error: e
    };
  }
}

const apiUpdateNotification = async (input) => {
  try {
    const response = await client.graphql({
      query: updateNotification,
      variables: {
        input
      },
      authMode: AUTH_MODE
    });
    const notification = response.data?.updateNotification;
    return {
      success: true,
      data: notification
    };
  } catch (e) {
    return {
      success: false,
      error: e
    };
  }
}

const apiDeleteNotification = async (id) => {
  try {
    const response = await client.graphql({
      query: deleteNotification,
      variables: {
        input: {
          id
        }
      },
      authMode: AUTH_MODE
    });
    return {
      success: true,
      data: response.data.deleteNotification
    };
  } catch (e) {
    return {
      success: false,
      error: e
    };
  }
}

const apiAddCreateNotificationListener = async (handler) => {
  try {
    const listener = await client.graphql({
      query: onCreateNotification,
      authMode: AUTH_MODE
    }).subscribe({
      next: ({ data }) => {
        const newNotification = data.onCreateNotification;
        handler(newNotification);
      },
      error: (error) => console.error(error)
    });
    return {
      success: true,
      data: listener
    }
  }
  catch (e) {
    return {
      success: false,
      error: e
    }
  }
}

const apiAddUpdateNotificationListener = async (handler) => {
  try {
    const listener = await client.graphql({
      query: onUpdateNotification,
      authMode: AUTH_MODE
    }).subscribe({
      next: ({ data }) => {
        const newNotification = data.onUpdateNotification;
        handler(newNotification);
      },
      error: (error) => console.error(error)
    });
    return {
      success: true,
      data: listener
    }
  }
  catch (e) {
    return {
      success: false,
      error: e
    }
  }
}

const apiAddDeleteNotificationListener = async (handler) => {
  try {
    const listener = await client.graphql({
      query: onDeleteNotification,
      authMode: AUTH_MODE
    }).subscribe({
      next: ({ data }) => {
        handler(data.onDeleteNotification);
      },
      error: (error) => console.error(error)
    });
    return {
      success: true,
      data: listener
    }
  }
  catch (e) {
    return {
      success: false,
      error: e
    }
  }
}

const apiRemoveListener = (listener) => {
  if (listener.unsubscribe) listener.unsubscribe();
}


export {
  apiAddCreateNotificationListener, apiAddDeleteNotificationListener, apiAddUpdateNotificationListener, apiCreateNotification, apiDeleteNotification, apiListNotifications, apiRemoveListener, apiUpdateNotification
};
